<template>
  <article>
    <vnt-header>{{title}}</vnt-header>

    <h2>{{balance}}</h2>

    <div class="items">
      <vnt-listview selectionMode="single">
        <vnt-listview-item v-for="item in items" :key="item.id" @pick="editItem" :item="item">
          <item-list-element :item="item" />
        </vnt-listview-item>
      </vnt-listview>
    </div>

  </article>
</template>

<script>
import { DateTime } from 'luxon'
import { getByYearAndMonth } from '../services/budgets'
import ItemListElement from './items/ItemListElement.vue'

export default {
  name: 'Month',

  props: ['year', 'month'],

  components: {
    ItemListElement
  },

  computed: {
    title() {
      const now = DateTime.fromObject({
        year: this.year,
        month: this.month,
        day: 1
      })
      return now.toLocaleString({ year: 'numeric', month: 'long' })
    }
  },

  data() {
    return {
      balance: 0,
      items: []
    }
  },

  methods: {
    editItem(item) {
      this.$router.push(`/month/${this.year}/${this.month}/item/${item.id}`)
    }
  },

  mounted() {
    getByYearAndMonth(this.year, this.month)
      .then(({ balance, items }) => {
        this.balance = balance
        this.items = items
      })
  }
}
</script>

<style scoped>
.vnt-listview {
  max-width: 400px;
}

.vnt-listview-item {
  margin: 12px 0;
}

.items {
  overflow: auto;
  max-height: 90vh;
}
</style>
